import {Injectable} from "@angular/core";
import {delay, Observable, Subject} from "rxjs";

class PendingRequest {
    httpRequest: Observable<any>;
    httpResponse: Subject<any>;

    constructor(observable: Observable<any>, subscription: Subject<any>) {
        this.httpRequest = observable;
        this.httpResponse = subscription;
    }
}

@Injectable()
export class HTTPQueue {
    private requests$ = new Subject<any>();
    private queue: PendingRequest[] = [];

    constructor() {
        this.requests$.subscribe(request => this.execute(request));
    }

    /** Call this method to add your http request to queue */
    invoke<RESULT>(httpObservable: Observable<RESULT>): Observable<RESULT> {
        return <Observable<RESULT>>this.addRequestToQueue(httpObservable);
    }

    private execute(request: PendingRequest) {
        //One can enhance below method to fire post/put as well. (somehow .finally is not working for me)
        const req = request.httpRequest
            .pipe(
                delay(100)
            )
            .subscribe(res => {
                const sub = request.httpResponse;
                sub.next(res);
                sub.complete();
                this.queue.shift();
                this.startNextRequest();
            });
    }

    private addRequestToQueue<RESULT>(httpObservable: Observable<any>) {
        const sub = new Subject<RESULT>();
        const request = new PendingRequest(httpObservable, sub);
        this.queue.push(request);
        if (this.queue.length === 1) {
            this.startNextRequest();
        }
        return sub;
    }

    private startNextRequest() {
        // get next request, if any.
        if (this.queue.length > 0) {
            this.execute(this.queue[0]);
        }
    }
}
